import React from 'react';

import * as ModalTypes from 'constants/modalTypes';
import { getFlagValueForUser } from 'utilities/featureFlag';

import { EXP_CONSOLIDATE_SIGNUP_MODAL } from '../../../../shared/constants/featureFlag';

export default {
  [ModalTypes.ADMIN_SUSPEND_ACCOUNT_MODAL]: React.lazy(() =>
    import('components/admin/billing/suspend-account-modal.js')
  ),
  [ModalTypes.AUTOJOIN_MODAL]: React.lazy(() =>
    import('components/layout/navigation/AutoJoinModal')
  ),
  [ModalTypes.TEAM_INVITE_MODAL]: React.lazy(() =>
    import('components/manage-workspace/team-invite-modal-router')
  ),
  [ModalTypes.CSV_UPLOAD_MODAL]: React.lazy(() =>
    import('components/manage-workspace/csv-upload-modal')
  ),
  [ModalTypes.PRIVACY_CHANGE_MOVE_CONFIRMATION_MODAL]: React.lazy(() =>
    import(
      'components/share-video/share-video-widget/private-content/MoveConfirmationModal'
    )
  ),
  [ModalTypes.ADMIN_DELETE_ACCOUNT_WARNING_MODAL]: React.lazy(() =>
    import('components/profile/admin-delete-account-warning-modal')
  ),
  [ModalTypes.TRANSFER_LIBRARY_SELECTION_CONFIRMATION]: React.lazy(() =>
    import('components/content-transfer/LibrarySelectionConfirmationModal')
  ),
  [ModalTypes.LEAVE_WORKSPACE_CONFIRMATION]: React.lazy(() =>
    import('components/content-transfer/LeaveWorkspaceConfirmationModal')
  ),
  [ModalTypes.CHECKLIST_RECORD_BUTTON_MODAL]: React.lazy(() =>
    import(
      'components/layout/navigation/get-started-checklist/record-button-modal'
    )
  ),
  [ModalTypes.SUGGEST_PUBLISHING_PROMPT]: React.lazy(() =>
    import('components/share-video/tags-section/SuggestPublishingPromptModal')
  ),
  [ModalTypes.DOWNLOAD_VIDEO_INFO_MODAL]: React.lazy(() =>
    import('components/download-video-info-modal')
  ),
  [ModalTypes.SHARE_UI_MODAL]: React.lazy(() =>
    import('components/share-video/share-ui')
  ),
  [ModalTypes.ADD_LOOM_SEARCH_MODAL]: React.lazy(() =>
    import('components/share-video/add-search-ui')
  ),
  [ModalTypes.DESTINATION_WELCOME_TOUR_MODAL]: React.lazy(() =>
    import('components/destination-welcome-tour-modal')
  ),
  [ModalTypes.DESTINATION_SEARCH_MODAL]: React.lazy(() =>
    import('components/destination-search')
  ),
  [ModalTypes.DESTINATION_MOVE_MODAL]: React.lazy(() =>
    import('components/destination-move-modal')
  ),
  [ModalTypes.SIGNUP_MODAL]: React.lazy(() =>
    import('components/signup/signup-modal')
  ),
  [ModalTypes.FORGOT_PASSWORD_MODAL]: React.lazy(() =>
    import('components/signup/forgot-password-modal')
  ),
  [ModalTypes.VERIFY_EMAIL_MODAL]: React.lazy(() =>
    import('components/signup/verify-email-modal')
  ),
  [ModalTypes.REQUEST_UPGRADE_MODAL]: React.lazy(() =>
    import('components/request-upgrade-modal')
  ),
  [ModalTypes.DATA_RETENTION_PREVIEW_MODAL]: React.lazy(() =>
    import('components/manage-workspace/data/data-retention-preview-modal')
  ),
  [ModalTypes.SHARE_RECORD_REPLY_SIGNUP_MODAL]: React.lazy(async () => {
    const flagValue = await getFlagValueForUser(EXP_CONSOLIDATE_SIGNUP_MODAL);

    if (flagValue === 'variant-1') {
      return import(
        'components/share-video/share-record-reply-signup-modal-consolidated-variation-1'
      );
    }

    if (flagValue === 'variant-2') {
      return import(
        'components/share-video/share-record-reply-signup-modal-consolidated-variation-2'
      );
    }

    return import('components/share-video/share-record-reply-signup-modal');
  }),
  [ModalTypes.EDIT_PROFILE_MODAL]: React.lazy(() =>
    import('components/user-profile/profile-page/edit-profile-modal')
  ),
  [ModalTypes.CONTACT_SUPPORT_MODAL]: React.lazy(() =>
    import('components/help-bubble/contact-support-modal')
  ),
  [ModalTypes.CONTACT_SUPPORT_CONFIRMATION_MODAL]: React.lazy(() =>
    import('components/help-bubble/contact-support-confirmation-modal')
  ),
  [ModalTypes.WORKSPACE_SELECTOR_MODAL]: React.lazy(() =>
    import('components/default-workspace-modal')
  ),
  [ModalTypes.CREATE_NEW_WORKSPACE_MODAL]: React.lazy(() =>
    import('components/layout/header/createWorkspaceModal')
  ),
  [ModalTypes.CONFIRM_DELETE_ITEM_MODAL]: React.lazy(() =>
    import('components/confirm-delete-item-modal')
  ),
  [ModalTypes.UNPUBLISH_VIDEO_CONFIRMATION_MODAL]: React.lazy(() =>
    import('components/video-card/unpublish-video-confirmation-modal')
  ),
  [ModalTypes.WORKSPACE_CONTACTS_MODAL]: React.lazy(() =>
    import('components/manage-workspace/integrations/inviteModal')
  ),
  [ModalTypes.WORKSPACE_CONTACTS_CONFIRMATION_MODAL]: React.lazy(() =>
    import('components/manage-workspace/integrations/confirmationModal')
  ),
  [ModalTypes.PUBLISH_MOVE_CONFIRMATION_MODAL]: React.lazy(() =>
    import('components/destination-move-modal/PublishMoveConfirmationModal')
  ),
  [ModalTypes.SDK_RECORDING_LOADING_MODAL]: React.lazy(() =>
    import('components/record-button/LoadingModal')
  ),
  [ModalTypes.UNPUBLISH_FOLDER_CONFIRMATION_MODAL]: React.lazy(() =>
    import(
      'components/folder-card/folder-visibility/UnpublishConfirmationModal'
    )
  ),
  [ModalTypes.ANON_CREATOR_SIGNUP_MODAL]: React.lazy(async () => {
    const flagValue = await getFlagValueForUser(EXP_CONSOLIDATE_SIGNUP_MODAL);

    switch (flagValue) {
      case 'variant-1':
        return import(
          'components/share-video/anon-creator-auth-modal-variant-1'
        );
      case 'variant-2':
        return import(
          'components/share-video/anon-creator-auth-modal-variant-2'
        );
      default:
        return import('components/share-video/anon-creator-auth-modal');
    }
  }),
  [ModalTypes.ANON_CREATOR_CLAIM_MODAL]: React.lazy(async () => {
    const flagValue = await getFlagValueForUser(EXP_CONSOLIDATE_SIGNUP_MODAL);

    if (flagValue.includes('variant')) {
      return import('components/share-video/anon-creator-claim-modal-variant');
    }

    return import('components/share-video/anon-creator-claim-modal');
  }),
};
